import React, { useContext } from 'react';

import { Grid, Stack } from '@mui/material';

import { IUser } from '../../types/user.type';
import UserContext from '../../user-context';
import UserForm from './components/UserForm';
import UserInfo from './components/UserInfo';

const Profile = React.memo(() => {
  const { user, setUser } = useContext(UserContext);

  const handleSave = React.useCallback(
    (data: IUser) => {
      setUser(data);
    },
    [setUser],
  );

  if (!user) {
    return null;
  }

  return (
    <Stack>
      <Grid container spacing={2}>
        <Grid size={2}>
          <UserInfo user={user} />
        </Grid>

        <Grid size={10}>
          <UserForm user={user} onSave={handleSave} />
        </Grid>
      </Grid>
    </Stack>
  );
});

export default Profile;
